import axios from '../request/http';

const Genealogy = {


    //获取家谱数据配置列表
    getGenealogyDictList(params) {
        return axios.get("/hemei-admin/villageGenealogy/dic/getGenealogyDictList", { params });
    },

    //获取某一配置内容详情
    getImSysDictInfoListByDictCode(params) {
        return axios.get("/hemei-admin/villageGenealogy/dic/getImSysDictInfoListByDictCode", { params });
    },
    //添加世系人物数据配置
    addImSysDictInfo(data) {
        return axios.post("/hemei-admin/villageGenealogy/dic/addImSysDictInfo", data);
    },
    //获取某一配置内容详情分页
    getImSysDictInfoListByDictId(params) {
        return axios.get("/hemei-admin/villageGenealogy/dic/getImSysDictInfoListByDictId", { params });
    },
    //更新/删除世系人物数据配置
    updateImSysDictInfo(params) {
        return axios.get("/hemei-admin/villageGenealogy/dic/updateImSysDictInfo", { params });
    },
    //族谱列表获取
    getVillageGenealogyNameList(params) {
        return axios.get("/hemei-admin/villageGenealogy/getVillageGenealogyNameList", { params });
    },
    //族谱信息新增
    addVillageGenealogy(data) {
        return axios.post("/hemei-admin/villageGenealogy/addVillageGenealogy", data);
    },
    //获取族谱详细信息
    getVillageGenealogyDetail(params) {
        return axios.get("/hemei-admin/villageGenealogy/getVillageGenealogyDetail", { params });
    },
    //修改/删除族谱信息
    updateVillageGenealogy(data) {
        return axios.post("/hemei-admin/villageGenealogy/updateVillageGenealogy", data);
    },
    //删除谱系
    deletePedigree(data) {
        return axios.post("/hemei-admin/village/genealogy/pedigree/delete/" + data);
    },
    //乡村搜索接口
    villageInfosearch(params) {
        return axios.get("/hemei-admin/villageInfo/search", { params });
    },
    //根据乡村id搜索乡村族谱
    getGenealogyList(params) {
        return axios.get("/hemei-admin/villageGenealogy/getGenealogyList", { params });
    },
    //获取谱系人物详情
    detailPedigree(params) {
        return axios.get("/hemei-admin/village/genealogy/pedigree/detail/" + params);
    },
    // 获取谱系树
    treePedigree(params) {
        return axios.get("/hemei-admin/village/genealogy/pedigree/tree", { params });
    },
    // 谱系录入
    addPedigree(data) {
        return axios.post("/hemei-admin/village/genealogy/pedigree/add", data);
    },
    // 谱系修改
    editPedigree(data) {
        return axios.put("/hemei-admin/village/genealogy/pedigree/edit", data);
    },
    // 谱系删除
    deletePedigree(data) {
        return axios.delete("/hemei-admin/village/genealogy/pedigree/delete/" + data);
    },
    // 获取父母亲id
    parentIdsPedigree(params) {
        return axios.get("/hemei-admin/village/genealogy/pedigree/parentIds", { params });
    },
    // 导入模板】乡村族谱模版下载
    downloadGenealogyModel(data) {
        return axios.post("/hemei-admin/villageGenealogy/downloadGenealogyModel", data);
    },
    // 导入模版下载
    downloadModel(params) {
        return axios.get("/hemei-admin/file/downloadModel", { params });
    },
    // 导入谱系
    exportModel(data) {
        return axios.post("/hemei-admin/village/genealogy/pedigree/export", data);
    },
    // 获取列表展示数据姓氏列表数据
    getSurnamesGenealogyList(params) {
        return axios.get("/hemei-admin/surnamesGenealogy/getSurnamesGenealogyList", { params });
    },
    // 修改姓氏通谱数据状态
    updateSurnamesGenealogyStatus(params) {
        return axios.get("/hemei-admin/surnamesGenealogy/updateSurnamesGenealogyStatus", { params });
    },
    // 新增姓氏通谱
    addSurnameGenealogy(data) {
        return axios.post("/hemei-admin/surnamesGenealogy/addSurnameGenealogy", data);
    },
    // 获取某一姓氏的通谱数据
    getSurnamesGenealogyById(params) {
        return axios.get("/hemei-admin/surnamesGenealogy/getSurnamesGenealogyById", { params });
    },
    // 修改姓氏通谱数据内容
    updateSurnamesGenealogyContent(data) {
        return axios.post("/hemei-admin/surnamesGenealogy/updateSurnamesGenealogyContent",data);
    },
}
export default Genealogy;


// WEBPACK FOOTER //
// ./src/api/Genealogy.js